import { Reveal } from "../components/Reveal";
import { ThemeDark } from "../components/ThemeDark";

const stats = [
  { value: "2013", label: "Founded" },
  { value: "42", label: "Brands built" },
  { value: "★ 5.0", label: "Google rating" },
  { value: "Baqa al-Gharbiyye", label: "Based in" },
];

export default function Studio() {
  return (
    <main className="section page-top" data-testid="studio-page">
      <p className="eyebrow">Studio</p>
      <div className="studio-columns">
        <div>
          <h1 className="page-headline" data-testid="studio-headline">
            We don't decorate.
            <br />
            We define.
          </h1>
          <p className="studio-philosophy" data-testid="studio-philosophy">
            We believe in brands with a point of view. Not louder — clearer. We strip away
            everything that isn't the idea, then build the identity from what remains. The
            result is work that holds its shape in five years, not five weeks.
          </p>
        </div>
        <div className="studio-stats" data-testid="studio-stats">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 100}>
              <div className="stat">
                <span className="stat-value">{s.value}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <ThemeDark>
        <Reveal>
          <div className="studio-process" data-testid="studio-process">
            <p className="eyebrow">Process</p>
            <p>
              Every engagement starts with a question, not a moodboard: what does this brand
              refuse to be? From there — strategy, naming, identity, and the systems that
              carry it into the world. We work with a small number of clients at a time,
              and we finish what we start.
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="studio-image">
            <img
              src="https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1800&q=80"
              alt="Cactus studio space"
              loading="lazy"
              data-testid="studio-image"
            />
          </div>
        </Reveal>
      </ThemeDark>
    </main>
  );
}
